<script setup lang="ts">
import BaseStatistics from '@desktop/views/Relation/Sports/components/RelationView/BaseStatistics.vue'

import {
  playerStatIdConfigs,
  teamStatIdConfigs,
  teamStatsAccordionIdConfigs,
} from '../../configuration'
</script>

<template>
  <BaseStatistics
    :playerStatIdConfigs
    :teamStatIdConfigs
    :teamStatsAccordionIdConfigs
  />
</template>
